export enum FineFiltersMaxLengthEnum {
    NAME_MAX_LENGTH = 300,
    FISCAL_NUMBER_MAX_LENGTH = 300,
    // max notice number is 15 because filter is Long type and Long max value is 9223372036854775807
    // which has 19 characters, so width 15 we make sure that the input is inside valid values
    // and this is the max value without precision issues
    NOTICE_NUMBER_MAX_LENGTH = 15
}
